import Actions from '../../odata/actions';

const actions = new Actions('pickingList', 'pickingLists');

export default actions;
